var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-default"},[_c('my-header',{staticClass:"page-header",attrs:{"id":"myHeader"}}),_vm._v(" "),_c('div',{staticClass:"page-body"},[_vm._t("default",function(){return [_c('nuxt')]})],2),_vm._v(" "),_c('my-footer',{staticClass:"page-footer"}),_vm._v(" "),_c('cnzz')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }